import React from 'react'
import { createNgReactBridgeDirective } from '../../react-bridge'
import {
  ValueReportingDashboard,
  ValueReportingDashboardProps
} from '../../../components/value-reporting/vr-main'
import { ValueReportingFiltersProvider } from '../../../components/value-reporting/use-value-reporting-filters'
import { ErrorBoundary } from '../../../legacy-design-system/error-boundary/error-boundary'

function VrWrapper(props: ValueReportingDashboardProps) {
  const {
    organizationUuid,
    hostUrl,
    apiKey,
    authHeader,
    onBackToOldDashboard
  } = props
  return (
    <ValueReportingFiltersProvider>
      <ErrorBoundary>
        <ValueReportingDashboard
          authHeader={authHeader}
          organizationUuid={organizationUuid}
          hostUrl={hostUrl}
          apiKey={apiKey}
          onBackToOldDashboard={onBackToOldDashboard}
        />
      </ErrorBoundary>
    </ValueReportingFiltersProvider>
  )
}

export const reactVr = createNgReactBridgeDirective('reactVr', [], VrWrapper, [
  'organizationUuid',
  'apiKey',
  'hostUrl',
  'authHeader',
  'onBackToOldDashboard'
])
